// extracted by mini-css-extract-plugin
export default {"align-cc":"Map_align-cc__va8zt","align-lc":"Map_align-lc__7F1jc","align-rc":"Map_align-rc__zjgis","map":"Map_map__dd6T3"};